import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Carly Faye Foundation</h3>
            <p className="footer-description">
              Providing scholarships and GLO program for young girls to inspire them to dream, achieve and overcome.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=100064601145200" className="social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <Facebook size={18} />
              </a>
              <a href="https://www.instagram.com/carlyfayefoundation/" className="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <Instagram size={18} />
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Navigation</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/scholarships">Scholarships</Link></li>
              <li><Link to="/glo">GLO</Link></li>
              <li><Link to="/donate">Donate</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Programs</h4>
            <ul className="footer-links">
              <li><Link to="/scholarships">Academic Excellence</Link></li>
              <li><Link to="/scholarships">Athletic Achievement</Link></li>
              <li><Link to="/glo">Girls Lifting Others</Link></li>
            </ul>
          </div>
          

        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Carly Faye Foundation. All rights reserved.</p>
          <p className="footer-quote">
            "You Were Assigned This Mountain To Show Others It Can Be MOVED."
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 